/**
 * Zopim (now called zendesk chat) is the support chat widget.
 *
 * @see https://api.zopim.com/files/meshim/widget/controllers/LiveChatAPI-js.html
 */

const ZOPIM_SERVICE_ADDRESS = process.env.REACT_APP_ZOPIM_ADDRESS;
const ZOPIM_FONT_CONFIG = {
  custom: {
    urls: [process.env.REACT_APP_CLOUD_TYPOGRAPHY_URL]
  }
};
const ZOPIM_THEME_COLORS = {
  primary: '#5205bc',
  badge: '#5205bc',
  bubble: '#5205bc'
};

let onHideCallback = null;
let onShowCallback = null;

export function configureZopim(document, window) {
  let zopim = window.$zopim;

  if (!zopim) {
    // Run the embed script for the zopim widget.
    zopim = c => {
      zopim._.push(c);
    };
    zopim.s = document.createElement('script');
    const mountPoint = document.getElementsByTagName('script')[0];
    zopim.set = o => {
      zopim.set._.push(o);
    };
    zopim._ = [];
    zopim.set._ = [];
    zopim.s.async = !0;
    zopim.s.setAttribute('charset', 'utf-8');
    zopim.s.src = ZOPIM_SERVICE_ADDRESS;
    zopim.t = +new Date();
    zopim.s.type = 'text/javascript';
    mountPoint.parentNode.insertBefore(zopim.s, mountPoint);

    window.$zopim = zopim;
  }

  window.$zopim(() => {
    window.$zopim.livechat.window.setTitle('Support');

    window.$zopim.livechat.theme.setColors(ZOPIM_THEME_COLORS);
    window.$zopim.livechat.theme.setFontConfig(
      ZOPIM_FONT_CONFIG,
      'Gotham SSm A, Gotham SSm B'
    );
    window.$zopim.livechat.theme.reload(); // apply new theme settings.

    window.$zopim.livechat.hideAll();

    window.$zopim.livechat.window.onHide(() => {
      // Hide all components when the window is hidden.
      window.$zopim.livechat.hideAll();
      if (onHideCallback) {
        onHideCallback();
      }
    });

    window.$zopim.livechat.window.onShow(() => {
      if (onShowCallback) {
        onShowCallback();
      }
    });
  });

  return window.$zopim;
}

export function toggleChat() {
  window.$zopim(() => {
    window.$zopim.livechat.window.toggle();
    // Hide all components if toggling off.
    if (!window.$zopim.livechat.window.getDisplay()) {
      window.$zopim.livechat.hideAll();
      if (onHideCallback) {
        onHideCallback();
      }
    } else if (onShowCallback) {
      onShowCallback();
    }
  });
}

export function setCallbacks(onHide, onShow) {
  onHideCallback = onHide;
  onShowCallback = onShow;
}

export function setUserData(user) {
  window.$zopim(() => {
    window.$zopim.livechat.setName(user.displayName);
    window.$zopim.livechat.setEmail(user.email);
  });
}

export default window.$zopim;



// WEBPACK FOOTER //
// ./src/utils/zopim.js